import { InviteClient, InviteClientParams } from '~src/components/templates/InviteClient';

const ClientOnboarding = () => <InviteClient />;

const ClientOnboardingParams = () => <InviteClientParams />;

export { ClientOnboarding, ClientOnboardingParams };
